import { useResetRecoilState } from 'recoil'
import * as reportInsight from 'src/atoms/report-insight'

export const useResetReportSettings = () => {
  const resetWidgets = useResetRecoilState(reportInsight.widgets)
  const resetPageSize = useResetRecoilState(reportInsight.reportPageSize)
  const resetPageOrientation = useResetRecoilState(reportInsight.reportOrientation)
  const resetReportCoverPage = useResetRecoilState(reportInsight.reportCoverPage)
  const resetReportHeader = useResetRecoilState(reportInsight.reportHeader)
  const resetReportFooter = useResetRecoilState(reportInsight.reportFooter)

  const resetReportSettings = () => {
    resetWidgets()
    resetPageSize()
    resetPageOrientation()
    resetReportCoverPage()
    resetReportHeader()
    resetReportFooter()
  }
  return resetReportSettings
}
